import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getSuppliersByPage } from '../../ApiServices/SupplierServices';
import { RootState } from '../reduxStore';
import { hideLoader, showLoader } from './loaderSlice';
import { showErrorSnackbar } from './snackbarSlice';
import { t } from 'i18next';

export const initialState = {
  value: { totalCount: -1, data: [] },
  loading: false,
  error: null,
  rowsPerPage: 10,
  pageNo: 0,
  selectedValue: null,
  sortBy: '',
  sortDirection: 0,
  filter: [{}]
};

const suppliersSlice = createSlice({
  name: 'suppliers',
  initialState: initialState,
  reducers: {
    clearSupplierState(state: any) {
      state.rowsPerPage = initialState.rowsPerPage;
      state.pageNo = initialState.pageNo;
      state.value = initialState.value;
      state.loading = false;
      state.error = null;
      state.selectedValue = initialState.selectedValue;
      state.filter = initialState.filter;
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchSuppliers.fulfilled, (state: any, action: any) => {
      state.error = initialState.error;
      state.loading = initialState.loading;
      state.selectedValue = initialState.selectedValue;
      state.value = action?.payload?.data;
      state.pageNo = action?.meta?.arg?.page;
      state.rowsPerPage = action?.meta?.arg?.limit;
      state.sortBy = action?.meta?.arg?.sortBy;
      state.sortDirection = action?.meta?.arg?.sortDirection;
      state.filter = action?.meta?.arg?.filter;
    });
    builder.addCase(fetchSuppliers.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error?.message;
      state.loading = false;
      state.selectedValue = initialState?.selectedValue;
    });
  }
});

export const suppliersState = (state: RootState) => state?.suppliers;
export const { clearSupplierState } = suppliersSlice.actions;
export default suppliersSlice.reducer;

export const fetchSuppliers = createAsyncThunk(
  'suppliers/fetchSuppliers',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('FETCHING_SUPPLIERS') }));
      return fulfillWithValue(await getSuppliersByPage(payload));
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);
